import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { Delete } from "lucide-react";

export const EmployeePinPad = ({ username, setUsername, pin, setPin, error, submitting, pressDigit }) => (
  <div
    data-testid="employee-login-form"
    className="space-y-4 bg-white border border-[#33424f]/20 border-t-0 p-6 shadow-[4px_4px_0_0_rgba(51,66,79,0.08)]"
  >
    <div>
      <Label className="subtitle text-[10px] uppercase tracking-[0.2em] text-[#50493b]">
        Username
      </Label>
      <Input
        data-testid="employee-username-input"
        value={username}
        autoFocus
        onChange={(e) => setUsername(e.target.value)}
        placeholder="e.g. FirstnameLastname"
        className="mt-2 border-[#33424f]/30 focus:border-[#39678f] focus:ring-[#39678f] font-body text-lg"
      />
    </div>
    <div>
      <Label className="subtitle text-[10px] uppercase tracking-[0.2em] text-[#50493b]">
        6-digit PIN
      </Label>
      {/* Pin display */}
      <div data-testid="pin-display" className="mt-2 flex gap-2 justify-center">
        {[0, 1, 2, 3, 4, 5].map((i) => (
          <div
            key={i}
            className={`w-10 h-12 border-2 flex items-center justify-center text-xl font-display ${
              pin.length > i ? "border-[#39678f] bg-[#e6f3ff] text-[#33424f]" : "border-[#33424f]/30 bg-white"
            }`}
          >
            {pin.length > i ? "•" : ""}
          </div>
        ))}
      </div>
      {/* Pin pad */}
      <div className="mt-4 grid grid-cols-3 gap-2">
        {[1, 2, 3, 4, 5, 6, 7, 8, 9].map((d) => (
          <button
            key={d}
            data-testid={`pin-key-${d}`}
            type="button"
            disabled={submitting}
            onClick={() => pressDigit(String(d))}
            className="h-14 border border-[#33424f]/30 bg-[#f5f1ec] hover:bg-[#e6e0db] active:bg-[#ccb795] subtitle text-2xl text-[#33424f] disabled:opacity-50"
          >
            {d}
          </button>
        ))}
        <button
          data-testid="pin-key-clear"
          type="button"
          disabled={!pin}
          onClick={() => setPin("")}
          className="h-14 border border-[#33424f]/30 bg-white hover:bg-[#fbe4ea] subtitle text-xs uppercase tracking-[0.15em] text-[#7a0024] disabled:opacity-30"
        >
          Clear
        </button>
        <button
          data-testid="pin-key-0"
          type="button"
          disabled={submitting}
          onClick={() => pressDigit("0")}
          className="h-14 border border-[#33424f]/30 bg-[#f5f1ec] hover:bg-[#e6e0db] active:bg-[#ccb795] subtitle text-2xl text-[#33424f] disabled:opacity-50"
        >
          0
        </button>
        <button
          data-testid="pin-key-back"
          type="button"
          disabled={!pin}
          onClick={() => setPin(pin.slice(0, -1))}
          className="h-14 border border-[#33424f]/30 bg-white hover:bg-[#e6e0db] flex items-center justify-center text-[#33424f] disabled:opacity-30"
        >
          <Delete className="w-5 h-5" />
        </button>
      </div>
    </div>

    {error && (
      <div
        data-testid="employee-login-error"
        className="border border-[#b30035] bg-[#fbe4ea] text-[#7a0024] text-sm p-3 font-body"
      >
        {error}
      </div>
    )}
    {submitting && (
      <div className="text-center text-xs subtitle uppercase tracking-[0.2em] text-[#50493b]">
        Verifying…
      </div>
    )}
  </div>
);
